Rover.models.Phone = Backbone.Model.extend({
  initialize() {
    return this;
  },
  defaults: {
    id: null,
    phone_number: '',
    is_verified: null,
    verify_method: null,
    verify_token: null,
    error_message: null,
    opt_in: false,
    errorMessages: null,
  },
  url() {
    return Rover.urls.phoneVerify;
  },
  validate(attributes) {
    let phone = attributes.phone_number.replace(/[^0-9]/g, ''),
      msg = '* Phone number must be in XXX-XXX-XXXX format';
    if (phone.length != 10) {
      this.set('errorMessages', msg);
      return msg;
    }
  },
  isVerified() {
    return !!this.get('is_verified');
  },
  verify(token, cb) {
    this.save(
      { verify_token: token },
      {
        success(model, resp) {
          if (_.isFunction(cb)) {
            cb(!resp.is_verified, model, resp);
          }
        },
        error(model, resp) {
          if (_.isFunction(cb)) {
            cb(true, model, resp);
          }
        },
      }
    );
  },
});



// WEBPACK FOOTER //
// ./js/models/phone.js